export interface TokenResponse {
  token: string;
}

export interface ScoreResponse {
  ok: boolean;
  rank?: number;
  error?: string;
}

export interface ScoreEntry {
  name: string;
  score: number;
  rows_survived: number;
  captures: number;
  time_seconds: number;
}

export interface ScoresResponse {
  scores: ScoreEntry[];
}

export async function requestToken(): Promise<TokenResponse> {
  const res = await fetch("/api/token", { method: "POST" });
  if (!res.ok) throw new Error("Failed to get token");
  return res.json();
}

export async function submitScore(
  token: string,
  name: string,
  score: number,
  rowsSurvived: number,
  captures: number,
  timeSeconds: number,
): Promise<ScoreResponse> {
  const res = await fetch("/api/score", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, name, score, rowsSurvived, captures, timeSeconds }),
  });
  return res.json();
}

export async function fetchScores(): Promise<ScoresResponse> {
  const res = await fetch("/api/scores");
  if (!res.ok) throw new Error("Failed to fetch scores");
  return res.json();
}
